import React, { useState } from 'react';
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';

import { authActions, alertActions } from '../../../_services/essentials/store';
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import { Button, Link } from "@mui/material";
import { history } from "../../../_services/essentials/helpers";
import { ArrowForwardOutlined } from '@mui/icons-material';
import MarkEmailReadOutlinedIcon from '@mui/icons-material/MarkEmailReadOutlined';
export { ForgotPassword };

function ForgotPassword() {
    const dispatch = useDispatch();

    // form validation rules
    const validationSchema = Yup.object().shape({
        email: Yup.string().trim().required('Email is required'),
    });
    const formOptions = { resolver: yupResolver(validationSchema) };

    // get functions to build form with useForm() hook
    const { register, handleSubmit, formState, watch } = useForm(formOptions);
    //    const { errors, isSubmitting } = formState;
    const { errors } = formState;
    const emailID = watch('email', '');
    const [EmailSent, setEmailSent] = useState(false);
    async function onSubmit({ email }) {
        try {
            // dispatch(authActions.resetPassword({ email }));
            let message = await dispatch(authActions.resetPassword_v2({ email })).unwrap();
            if (message !== 'Incorrect Username') {
                setEmailSent(true);
            }
            else
                dispatch(alertActions.warning({ message, showAfterRedirect: false }));
        } catch (error) {
            dispatch(alertActions.error(error));
        }
    }

    return (
        <Stack variant="outlined" sx={{
            // p: 2,
            pt: 26,
            justifyContent: 'center',
            alignItems: 'center',
        }}>
            <Stack
                sx={{
                    mb: 5
                }}
            >
                <img
                    src="../assets/images/healthcare/kyol_logo.png"
                    alt="KeyInsight Data Logo"
                    style={{ height: '106px', justifyContent: 'center' }}

                /></Stack>
            <Stack
                sx={{
                    // minWidth: '900px',
                    justifyContent: 'space-between', flexGrow: '1', gap: 1
                }}
            >
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Box sx={{
                        width: '100%',
                    }}
                    >

                        {!EmailSent ? (
                            <>
                                <Typography
                                    // component="h1"
                                    variant="h5"
                                    sx={{ ml: 5, mr: 5, fontWeight: '600', fontSize: '25px' }}
                                >
                                    Forgot your Password?
                                </Typography>
                                <Stack direction={"column"}
                                    sx={{
                                        justifyContent: 'space-between', width: '100%', maxWidth: '365px', mt: 4
                                    }}
                                >
                                    <FormControl fullWidth>
                                        <Typography variant='body1' sx={{ mb: 0.5, width: '100%' }}>Enter your email
                                        </Typography>
                                        <TextField

                                            id="email"
                                            type="text"
                                            name="email"
                                            placeholder="your@email.com"
                                            autoComplete="off"
                                            autoFocus
                                            fullWidth
                                            variant="outlined"
                                            sx={{
                                                ariaLabel: 'email', mb: 4, borderRadius: '12px', maxWidth: '350px',
                                                width: '100%'
                                            }}
                                            defaultValue={""}
                                            {...register('email', { required: true })}
                                            error={Boolean(errors.email)}
                                            helperText={errors.email ? errors.email.message : ""}
                                            inputProps={{
                                                maxLength: 60,
                                            }}
                                        />
                                    </FormControl>
                                    <Stack direction={"row"}
                                        sx={{
                                            justifyContent: 'space-between',
                                            // p: 2,
                                            width: '97%',
                                            mb: 2
                                        }}
                                    >
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            endIcon={<ArrowForwardOutlined />}
                                            sx={{
                                                borderRadius: '16px', width: '100%', textTransform: 'uppercase',
                                                fontWeight: '500', fontSize: '18px'
                                            }}
                                        >
                                            Send Password
                                        </Button >
                                    </Stack>

                                </Stack>
                            </>) : (

                            <Stack direction={"column"}
                                sx={{
                                    justifyContent: 'center', width: '100%',
                                }}
                            >
                                <Stack direction={"row"}
                                    sx={{
                                        justifyContent: 'center',
                                        // p: 2,
                                        mb: 2
                                    }}
                                >
                                    <Typography
                                        variant="h5"
                                        sx={{ fontWeight: '600', fontSize: '25px' }}
                                    >
                                        Email Send
                                    </Typography>
                                </Stack>
                                <Stack direction={"row"}
                                    sx={{
                                        justifyContent: 'center',
                                        // p: 2,
                                        mb: 2
                                    }}
                                >
                                    <MarkEmailReadOutlinedIcon fontSize='large'
                                        style={{ height: '106px', width: '106px', justifyContent: 'center', color: '#39B84D' }}

                                    />
                                </Stack>
                                <Stack direction={"row"}
                                    sx={{
                                        justifyContent: 'center',
                                        // p: 2,
                                        mb: 2
                                    }}
                                >
                                    <Typography variant='body1' sx={{ mb: 0.5, width: '75%' }}>
                                        We have sent email to {emailID},
                                        Please check your inbox.
                                    </Typography>
                                </Stack>
                            </Stack>
                        )}
                        <Stack direction={"row"}
                            sx={{
                                justifyContent: 'center',
                                p: 2,
                                width: '100%'
                            }}
                        >
                            <Link
                                onClick={() => history.navigate(-1)}
                                variant="body2"
                                sx={{ alignSelf: 'center', cursor: 'pointer' }}
                            >
                                Back to Login
                            </Link>
                        </Stack>
                    </Box>
                </form>
            </Stack>
        </Stack >
    )
}